const allowedNames = [
    'Nursing Assistants',
    'Home Health and Personal Care Aides',
    'Licensed Practical and Licensed Vocational Nurses',
    'Registered Nurses',
    'Nursing Instructors and Teachers Postsecondary',
    'Nurse Midwives',
    // 'Others'
];

const allowedNamesFree = [
    'Nursing Assistants',
    'Home Health and Personal Care Aides',
    'Licensed Practical and Licensed Vocational Nurses',
    'Registered Nurses',
    // 'Others'
];

const allowedRolesForFree = [
    'Nursing Assistants',
    'Home Health and Personal Care Aides',
    'Licensed Practical and Licensed Vocational Nurses',
    'Registered Nurses',
];

// const getFeatureAccess = (userPlan) => {
//     const plan = userPlan.plan?.toLowerCase() || 'free';
//     const isExpired = userPlan.expiryDate && new Date(userPlan.expiryDate) < new Date();

//     return {
//         __planExpired: isExpired,
//         role_selection_restriction_1: plan === 'free' || isExpired, // Free plan restrictions
//         role_selection_restriction_2: (plan === 'free' || plan === 'plus') || isExpired, // Plus plan restrictions
//     };
// };

// const { __planExpired, role_selection_restriction_1, role_selection_restriction_2 } = getFeatureAccess(userPlanData);

export {
    allowedNames,
    allowedNamesFree,
    allowedRolesForFree,
    //   getFeatureAccess,
    //   __planExpired,
    //   role_selection_restriction_1,
    //   role_selection_restriction_2
};